<template>
  <!-- 查看合同页面 -->
  <div class="wrap" style="overflow: hidden">
    <yd-navbar title="重置密码" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/login" slot="left">
        <yd-navbar-back-icon>登录</yd-navbar-back-icon>
      </router-link>
    </yd-navbar>
    <yd-cell-group>
      <yd-cell-item>
        <yd-icon slot="icon" name="phone3" size=".45rem"></yd-icon>
        <input type="tel" required v-model="userPhone" regex="mobile" slot="right" placeholder="请输入手机号码">
        <!-- ↓↓关键代码是这里↓↓ -->
        <yd-sendcode slot="right" v-model="start1" @click.native="sendCode" type="warning"></yd-sendcode>
        <!-- ↑↑关键代码是这里↑↑ -->
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">验证码：</span>
        <yd-input slot="right" required type="number" max="6" min="6" v-model="verifyCode" placeholder="请输入6位验证码"></yd-input>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">新密码：</span>
        <yd-input slot="right" required type="password" v-model="passwrord"  autocomplete="new-password"  min="6" max="18" placeholder="请输入密码"></yd-input>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">确认密码：</span>
        <yd-input slot="right" required type="password" v-model="enterPassword" min="6" max="18" placeholder="请再次输入密码"></yd-input>
      </yd-cell-item>
    </yd-cell-group>
    <yd-button type="primary" size="large" shape="circle" bgcolor="#2f6fff" color="#fff" @click.native="updatePsw">确认修改</yd-button>
  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
    data() {
        return {
          start1: false,
           userPhone:'',
           verifyCode:'',
           passwrord:'',
           enterPassword:'',
        }
    },
    methods: {
      sendCode() {
         if(!this.userPhone || this.userPhone.length !== 11){
                 this.$dialog.toast({
                  mes: '请输入正确的手机号码',
                  icon: 'error',
                  timeout: 1500
            });
            return

         }
          this.$dialog.loading.open('发送中...');
          axios({
              method: "post",
                url: baseUrl + "sendVerifyCode",
                params:{
                      phone:this.userPhone,
                  }
              }).then(resp => {
                if (resp.data.result||resp.data.result === "true") {
                  setTimeout(() => {
                      this.start1 = true;
                      this.$dialog.loading.close();
                      this.$dialog.toast({
                          mes: '验证码已发送',
                          icon: 'success',
                          timeout: 1500
                              });
                          }, 1000);
                }else{
                    this.$dialog.loading.close();
                     this.$dialog.toast({
                    mes: resp.data.message,
                    icon: 'error',
                    timeout: 1500
                  });
                }
           })
      },
    updatePsw(){
      if(!this.userPhone || this.userPhone.length !==11){
        this.$dialog.toast({ mes: "请正确的电话号码", timeout: 1500 });
          return
      }
      if(!this.verifyCode || this.verifyCode.length !==6){
        this.$dialog.toast({ mes: "请输入有效的验证码", timeout: 1500 });
          return
      }
      let pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$%^&*)(_+}{|:?><]).{6,20}$/;
      if(!pattern.test(this.passwrord)){
        this.$dialog.toast({ mes: "密码长度必须6到20位且包含大小写字母，数字以及特殊字符", timeout: 1500 });
        return
      }
      if(!this.enterPassword || this.passwrord  !== this.enterPassword){
        this.$dialog.toast({ mes: "两次输入的密码不一致", timeout: 1500 });
          return
      }
      axios({
         method: "post",
          url: baseUrl + "resetPsw",
          params:{
                password:this.passwrord,
                code:this.verifyCode,
                userPhone:this.userPhone
            }
        }).then(resp => {
          if (resp.data.result||resp.data.result === "true") {
               this.$dialog.toast({
                                mes: '重置成功',
                                icon: 'success',
                                timeout: 1500
                                    });
            this.$router.push({ path: "/login"});
          }
          })
      },
    },
  mounted() {

  }
}
</script>

<style scoped>
.tabbar-footer {
  position: fixed;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/forgot-password.vue